import { gql } from '@apollo/client';

export * from './beneficiaries.query.generated';

export const beneficiaries = gql`
  query beneficiaries($page: Int, $perPage: Int, $order: QueryOrderEnum, $orderBy: BeneficiariesOrderByEnum) {
    beneficiaries(page: $page, perPage: $perPage, order: $order, orderBy: $orderBy) {
      nodes {
        id
        companyName
        companyWebsite
        companyRegistrationNumber
        street
        streetNumber
        city
        postalCode
        region
        country
      }
      pagesCount
      nodesCount
      hasNextPage
      hasPreviousPage
    }
  }
`;
